__turbopack_context__.v({
  "floating": "SponsoredBanner-module-scss-module__NRHUxG__floating",
  "margin": "SponsoredBanner-module-scss-module__NRHUxG__margin",
  "placeholder": "SponsoredBanner-module-scss-module__NRHUxG__placeholder",
  "sponsoredBanner": "SponsoredBanner-module-scss-module__NRHUxG__sponsoredBanner",
});
